import { render, staticRenderFns } from "./NavComponent.vue?vue&type=template&id=fb1a556a&"
import script from "./NavComponent.vue?vue&type=script&lang=js&"
export * from "./NavComponent.vue?vue&type=script&lang=js&"
import style0 from "./NavComponent.vue?vue&type=style&index=0&id=fb1a556a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports